import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53663)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 10.9605H-0.000488281V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H49.1374C49.6135 8.62061 49.9995 9.00664 49.9995 9.48271L49.9994 10.9605Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 10.96H-0.000488281V13.2998H49.9994V10.96Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 13.3008H-0.000488281V15.6406H49.9994V13.3008Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 15.6396H-0.000488281V17.9795H49.9994V15.6396Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 17.9805H-0.000488281V20.3203H49.9994V17.9805Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 20.3203H-0.000488281V22.6602H49.9994V20.3203Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 22.6602H-0.000488281V25H49.9994V22.6602Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 25H-0.000488281V27.3398H49.9994V25Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 29.6801H-0.000488281V25.8623H0.861619L0.861815 27.34H49.9994V29.6801Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 29.6797H-0.000488281V32.0195H49.9994V29.6797Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 32.0195H-0.000488281V34.3594H49.9994V32.0195Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 34.3604H-0.000488281V36.7002H49.9994V34.3604Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 36.6992H-0.000488281V39.0391H49.9994V36.6992Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1373 41.3795H0.861619C0.385546 41.3795 -0.000488281 40.9935 -0.000488281 40.5174V39.0396H49.9994V40.5174C49.9994 40.9935 49.6134 41.3795 49.1373 41.3795Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.1719 27.3398H0.861619C0.385546 27.3398 -0.000488281 26.9538 -0.000488281 26.4777V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H30.1719C30.648 8.62061 31.034 9.00664 31.034 9.48271V26.4777C31.0339 26.954 30.648 27.3398 30.1719 27.3398Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.18781 17.9714C8.18781 14.7109 10.8343 12.0661 14.0917 12.0661C14.9113 12.0661 15.6906 12.2339 16.4004 12.5362C16.4925 12.5755 16.5619 12.4472 16.4792 12.3908C15.3049 11.5914 13.8688 11.1534 12.3283 11.2335C8.94171 11.4096 6.17248 14.1374 5.95354 17.5216C5.69895 21.4579 8.81378 24.7187 12.6878 24.7187C14.0878 24.7187 15.3892 24.2874 16.4699 23.556C16.5531 23.4997 16.4842 23.3712 16.3917 23.4104C15.6843 23.7104 14.9081 23.8768 14.0919 23.8768C10.8343 23.8767 8.18781 21.2319 8.18781 17.9714Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.6838 17.9713L24.1796 17.0056C24.303 16.9578 24.261 16.7736 24.1291 16.7841L21.4623 16.9977L23.2949 15.0387C23.3853 14.9421 23.2675 14.7946 23.1533 14.8612L20.8371 16.2123L21.6365 13.6561C21.6759 13.5299 21.5058 13.448 21.4319 13.5575L19.9325 15.7787L19.5478 13.1276C19.5289 12.9966 19.3398 12.9965 19.3207 13.1275L19.075 14.805L18.973 15.515L18.9338 15.7788L17.4343 13.5595C17.3603 13.4499 17.19 13.532 17.2298 13.6581L18.0321 16.2122L15.7161 14.8611C15.6018 14.7944 15.4841 14.942 15.5745 15.0386L17.407 16.9976L14.7395 16.784C14.6076 16.7735 14.5655 16.9577 14.6889 17.0055L17.1871 17.9712L14.6888 18.9371C14.5653 18.9849 14.6075 19.1692 14.7394 19.1586L17.407 18.945L15.5744 20.9089C15.4841 21.0057 15.6021 21.153 15.7163 21.0862L18.0322 19.7303L17.2299 22.2844C17.1902 22.4106 17.3603 22.4927 17.4344 22.383L18.9339 20.1637L18.9731 20.4338L19.0751 21.1375L19.3209 22.8195C19.34 22.9506 19.5291 22.9504 19.548 22.8194L19.9327 20.1639L21.4321 22.3851C21.5061 22.4946 21.6762 22.4129 21.6367 22.2865L20.8373 19.7303L23.1532 21.0862C23.2673 21.153 23.3853 21.0057 23.2951 20.9089L21.4624 18.945L24.1293 19.1586C24.2612 19.1692 24.3033 18.9849 24.1798 18.9371L21.6838 17.9713Z",
					fill: "#FFE15A"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53663",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMyFlag);
export { ForwardRef as ReactComponent };
